import React from "react";
import "./Marketplace.scss";
import dashboardIcon from "../../images/settings-dashboard.svg";
import programIcon from "../../images/settings-program.svg";
import CRMIcon from "../../images/settings-crm.svg";
import reportingIcon from "../../images/settings-reporting.svg";
import { Link, useNavigate } from "react-router-dom";
import BaseButton from "../../components/UI/BaseButton/BaseButton";

function Marketplace() {
  //loop through the setting options to add it to the list of settings
  //will need to add url to the link to navigate to the correct page

  // TODO update the options to have link (as seen in settings.jsx) and navigate to page with 3rd party integrations
  const navigate = useNavigate();
  const settingOptions = [
    {
      icon: dashboardIcon,
      option: "Remittance",
      description:
        "Allow users to send money internationally with various services such as MoneyGram, Western Union and more",
      link: "/remittance",
    },
    {
      icon: programIcon,
      option: "Loans",
      description:
        "Integrate with our loans providers, allowing seamless loan application, repayment, and tracking",
      link: "/remittance",
    },
    {
      icon: CRMIcon,
      option: "Mobile",
      description:
        "Mobile provider services that allow users to purchase talk, text, and data plans at the press of a button",
      link: "/remittance",
    },
    {
      icon: reportingIcon,
      option: "Compliance",
      description: "Dig deeper into transaction reporting and monitoring",
      link: "/remittance",
    },
    {
      icon: reportingIcon,
      option: "Analytics",
      description:
        "Get the best understanding of what users are doing on your app, see what they like and don't like",
      link: "/remittance",
    },
  ];

  const goBack = () => {
    navigate("/settings");
  };

  return (
    <div className="page-container settings-container">
      <div className="header-container">
        <div className="settings-page-title">Marketplace</div>
        <div>
          Modify your current services, or register for new services to your
          account.
        </div>
      </div>
      <div className="settings-center-container">
        <div className="row gap-3">
          {settingOptions.map((setting) => {
            return (
                <div className="settings-card col-3">
                                <Link
              to={`/marketplace${setting.link}`}
              className="settings-card-link"
            >
                  <div className="settings-card-title-container d-flex align-items-center">
                    <img src={setting.icon} alt={setting.option} loading="lazy" />
                    <p>{setting.option}</p>
                  </div>
                  <div className="settings-card-body">{setting.description}</div>
                    {/* {setting.option} */}
                    </Link>
                </div>
            );
          })}
        </div>
        <div className="return-button">
          <BaseButton
            buttonText={"Return to Admin Center"}
            onClick={goBack}
          ></BaseButton>
        </div>
      </div>
    </div>
  );
}

export default Marketplace;
